import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetCompany } from '../../Hooks/company/company.get.hooks';
import PropTypes from 'prop-types';

const CompanyDataProvider = ({
  id,
  children,
  loadingComponent: LoadingComponent,
}) => {
  const {
    data: company,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['company', id],
    queryFn: () => httpGetCompany(id),
    staleTime: 5 * 60 * 1000,
    retry: 5,
    select: (data) => ({
      users: data.users || [],
      company: data.company || [],
      address: data.company?.[0]?.address?.[0] || {},
    }),
  });

  if (isLoading) return <LoadingComponent />;
  if (isError) return <p>Error loading company data</p>;

  return children(company);
};
CompanyDataProvider.propTypes = {
  id: PropTypes.string,
  children: PropTypes.func,
  loadingComponent: PropTypes.elementType,
};

export default CompanyDataProvider;
